import { apiClient } from './api';
import { db } from './firebase';
import { collection, query, getDocs, orderBy } from 'firebase/firestore';

export interface PromotionalBanner {
  bannerId: string;
  title: string;
  imageUrl: string;
  linkUrl?: string;
  order: number;
  isActive: boolean;
  restaurantId: string;
  restaurantName?: string;
  createdAt: { seconds: number; nanoseconds: number };
  updatedAt: { seconds: number; nanoseconds: number };
}

/**
 * Listar banners (Directo a Firestore)
 */
export async function listPromotionalBanners(): Promise<PromotionalBanner[]> {
  try {
    const q = query(collection(db, 'promotional_banners'), orderBy('order', 'asc'));
    const snapshot = await getDocs(q);
    return snapshot.docs.map(doc => ({ bannerId: doc.id, ...doc.data() } as PromotionalBanner));
  } catch (error) {
    console.error("Error listing banners:", error);
    return [];
  }
}

// Las rutas/métodos deben coincidir con las Cloud Functions standalone (backend: modules/admin/promotional-banners.*)
export async function uploadPromotionalBanner(data: { imageUrl: string, restaurantId: string }) {
  const response = await apiClient.post('/uploadPromotionalBanner', data);
  return response.data;
}

export async function deletePromotionalBanner(bannerId: string) {
  const response = await apiClient.delete('/deletePromotionalBanner', { params: { bannerId } });
  return response.data;
}

export async function togglePromotionalBanner(bannerId: string) {
  const response = await apiClient.put('/togglePromotionalBanner', { bannerId });
  return response.data;
}

export async function reorderPromotionalBanners(data: { bannerIds: string[] }) {
  const response = await apiClient.put('/reorderPromotionalBanners', data);
  return response.data;
}

export const promotionalBannersService = {
  listBanners: listPromotionalBanners,
  upload: uploadPromotionalBanner,
  delete: deletePromotionalBanner,
  toggle: togglePromotionalBanner,
  reorder: reorderPromotionalBanners
};
